module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP1"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_vm._v("All men dream: but not equally. Those who dream by night in the dusty recesses of their minds wake in the day to find it was vanity, but the dreamers of the day are dangerous men, for they may act their dreams with open eyes, to make it possible.")]), _vm._v(" "), _c('p', {
    staticClass: "FMEPC-1"
  }, [_vm._v("T. E. Lawrence, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Seven Pillars of Wisdom")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6efe7073","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0